import styled from 'styled-components';

export const PillContainer = styled.nav`
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    position: relative;
`;